export class DeleteUsersFailure {
    static readonly type = '[User] DeleteUsersFailure';
}
